export const WHATSAPP_TEMPLATES_PAGE_KEY = 'ADMIN_WHATSAPP_TEMPLATES_PAGE';
